import React, { useContext, useState, useEffect } from "react";
import Constant from "../../../Constants";
import LanguageContext from "../../../../utils/Contexts/LanguageContext";
import axiosInstance from "../../../../utils/Requests/axios";
import toast from "react-hot-toast";
import { Loader } from "../../../Common";
import PageAvail from "../../../svg/PageAvail";
import ThemeContext from "../../../../utils/Contexts/ThemeContext";
import PageIndex from "../../../svg/PageIndex";
import LinkAllow from "../../../svg/LinkAllow";
import LinkFound from "../../../svg/LinkFound";
import Tick from "../../../svg/Tick";
import Cross from "../../../svg/Cross";
import CircleCheck from "../../../svg/Circle";

import "./style.css";

const Placement = ({
  domain,
  pageData,
  userData,
  id,
  fetchPageData,
  isHide,
  value,
}) => {
  const { placementData } = Constant();
  const [isValid, setValid] = useState(true);
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const [isLoading, setIsLoading] = useState(false);
  const [iconColor, setIconColor] = useState("#6C747A");
  const [formData, setFormdata] = useState({
    url: "",
    domain: "",
  });

  useEffect(() => {
    if (pageData?.url) {
      let url = pageData?.url?.replace(/^https?:\/\/[^/]+/, "");
      if (!url.startsWith("/")) {
        url = "/" + url;
      }
      const domainUrl =
        pageData?.url?.match(/^(?:https?:\/\/)?([^/]+)/)?.[0] || "";
      setFormdata({
        url: url,
        domain: domainUrl || domain,
      });
    }
  }, [pageData?.url, domain]);

  useEffect(() => {
    if (selectedTheme === "dark") {
      setIconColor("#6C747A");
    } else {
      setIconColor("#FFFFFF");
    }
  }, [selectedTheme]);

  const SideIcons = {
    0: <PageAvail stroke={iconColor} fill={iconColor} />,
    1: <PageIndex stroke={iconColor} fill={iconColor} />,
    2: <LinkAllow stroke={iconColor} fill={iconColor} />,
    3: <LinkFound stroke={iconColor} fill={iconColor} />,
  };

  const handleSubmit = () => {
    if (formData?.url?.trim() === "") {
      setValid(false);
      return;
    }
    setIsLoading(true);
    const url = `/users/${userData}/contracts/${id}/tasks`;
    // Extract domain from pageData if formData.domain is not available
    const domainBaseUrl =
      formData?.domain || (domain ? `https://${domain}` : "");
    // Normalize URL path
    const normalizedUrl = formData?.url?.startsWith("/")
      ? formData?.url
      : `/${formData?.url}`;
    // Construct payload
    const payload = {
      type: 501,
      article: {
        url: `${domainBaseUrl}${normalizedUrl}`,
      },
    };

    axiosInstance
      .post(url, payload)
      .then((response) => {
        const taskUuid = response?.data?.uuid || "";
        // call the api every 2 seconds to check the status of the task is complemeted
        if (taskUuid) {
          const checkStatus = setInterval(async () => {
            try {
              const statusResponse = await axiosInstance.get(
                `/users/${userData}/tasks/${taskUuid}`
              );
              if (statusResponse?.data?.status === "completed") {
                clearInterval(checkStatus);
                fetchPageData(true);
                setIsLoading(false);
              }
            } catch (error) {
              clearInterval(checkStatus);
              toast.error(t("There was an error checking task status"));
              setIsLoading(false);
            }
          }, 2000);
        }
      })
      .catch(() => {
        toast.error(t("Something went wrong"));
        setIsLoading(false);
      });
  };

  const dynamicSection4 =
    value?.annotation?.links?.length > 0
      ? {
          id: 4,
          heading: t("Links Found"),
          inputs: value.annotation.links.map((link, index) => ({
            id: 40 + index + 1,
            title: link.anchor,
          })),
        }
      : null;
  const hasChecks = pageData?.checks?.length > 0;
  const updatedPlacementData = hasChecks
    ? placementData
    : dynamicSection4
    ? [...placementData.filter((section) => section.id !== 4), dynamicSection4]
    : placementData.filter((section) => section.id !== 4);

  return (
    <>
      <div>
        <div className="placement_main">
          <div className="input_placement">
            <div class="input-group main_input_placement">
              <span
                className={
                  !isValid
                    ? "input_text_error input-group-text"
                    : "input-group-text"
                }
                id="basic-addon3"
                style={{ color: "#919293" }}
              >
                {" "}
                {domain || ""}{" "}
              </span>
              <input
                type="text"
                value={formData?.url || ""}
                disabled={isHide}
                class={
                  !isValid
                    ? "placement_input_error form-control "
                    : " form-control placement_input"
                }
                id="basic-url"
                aria-describedby="basic-addon3"
                onChange={(e) => {
                  setFormdata({
                    ...formData,
                    url: e.target.value,
                  });
                  if (e.target.value) {
                    setValid(true);
                  }
                }}
              />
            </div>
            {!isValid && (
              <span className="error_text">
                <i class="bi bi-exclamation-triangle-fill"></i>{" "}
                {t("Please provide the location of the placement page")}
              </span>
            )}
          </div>
          {!isHide && (
            <button
              type="button"
              class="btn btn-outline-primary placement_add"
              disabled={isLoading || !formData?.url}
              onClick={handleSubmit}
              style={{ width: "80px", height: "41px" }}
            >
              {isLoading ? (
                <Loader />
              ) : (
                <>{pageData?.url ? t("Change") : t("Add")}</>
              )}
            </button>
          )}
        </div>
      </div>
      {/* placement validation */}
      <div className="divider-center " style={{ marginTop: "20px" }}>
        {t("Placement Validation")}
      </div>
      <div style={{ padding: "20px" }}>
        <div className="platement_validation">
          {/* {placementData &&
  placementData.map((section) => {
    const hasChecks = pageData?.checks && pageData.checks.length > 0;
    const relevantChecks = hasChecks
      ? pageData.checks.filter((check) => check.type === section.id)
      : [];

    // ✅ Render section if:
    // - pageData is null or has no checks
    // - OR if there are relevant checks
    // Skip section only when pageData exists AND has checks BUT none match this section

    if (pageData && hasChecks && relevantChecks.length === 0) {
      // Still render fallback `inputs`
      return (
        <div key={section.id}>
          <h6
            className="mb-3"
            style={{
              fontSize: "14px",
              fontWeight: "700",
              lineHeight: "150%",
            }}
          >
            {section.heading}
            <span
              style={{
                float: "right",
                fontSize: "16px",
                height: "26px",
                width: "26px",
                backgroundColor: "#2D3236",
                borderRadius: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {SideIcons[section.id - 1]}
            </span>
          </h6>

          {section.inputs.map((input) => (
            <div
              className="d-flex justify-content-start mb-1 mt-2"
              style={{ gap: "10px" }}
              key={input.id}
            >
              <CircleCheck height="16" width="16" />
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#919293",
                }}
              >
                {input.title}
              </span>
            </div>
          ))}

          {section.inputs.length <= 2 && (
            <span className="learn_badge">
              {t("Learn More")}{" "}
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                >
                  <path
                    d="M5.1 4.5H10.5M10.5 4.5V9.9M10.5 4.5L4.5 10.5"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </span>
          )}
        </div>
      );
    }

    return (
      <div key={section.id}>
        <h6
          className="mb-3"
          style={{
            fontSize: "14px",
            fontWeight: "700",
            lineHeight: "150%",
          }}
        >
          {section.heading}
          <span
            style={{
              float: "right",
              fontSize: "16px",
              height: "26px",
              width: "26px",
              backgroundColor: "#2D3236",
              borderRadius: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {SideIcons[section.id - 1]}
          </span>
        </h6>

        {(hasChecks ? relevantChecks : section.inputs).map((item) => (
          <div
            className="d-flex justify-content-start mb-1 mt-2"
            style={{ gap: "10px" }}
            key={item.id}
          >
            {hasChecks ? (
              item?.solved === null ? (
                <CircleCheck height="16" width="16" />
              ) : item?.solved === true ? (
                <Tick height="16" width="16" />
              ) : (
                <Cross height="16" width="16" />
              )
            ) : (
              <CircleCheck height="16" width="16" />
            )}
            <span
              style={{
                fontSize: "14px",
                fontWeight: "400",
                color: "#919293",
              }}
            >
              {hasChecks ? item.label : item.title}
            </span>
          </div>
        ))}

        {(hasChecks ? relevantChecks.length : section.inputs.length) <= 2 && (
          <span className="learn_badge">
            {t("Learn More")}{" "}
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
              >
                <path
                  d="M5.1 4.5H10.5M10.5 4.5V9.9M10.5 4.5L4.5 10.5"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </span>
        )}
      </div>
    );
  })} */}
          {updatedPlacementData &&
            updatedPlacementData.map((section) => {
              const hasChecks = pageData?.checks && pageData.checks.length > 0;
              // If pageData.checks exist, filter by type
              const relevantChecks = hasChecks
                ? pageData.checks.filter((check) => check.type === section.id)
                : [];
              // If no checks and no fallback inputs either, skip section
              if (hasChecks && relevantChecks.length === 0) {
                return null;
              }
              return (
                <div key={section.id}>
                  <h6
                    className="mb-3"
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      lineHeight: "150%",
                    }}
                  >
                    {section.heading}
                    <span
                      style={{
                        float: "right",
                        fontSize: "16px",
                        height: "26px",
                        width: "26px",
                        backgroundColor: "#2D3236",
                        borderRadius: "50px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {SideIcons[section.id - 1]}
                    </span>
                  </h6>
                  {hasChecks
                    ? relevantChecks.map((check) => (
                        <div
                          className="d-flex justify-content-start mb-1 mt-2"
                          style={{ gap: "10px" }}
                          key={check.id}
                        >
                          {check?.solved === null ? (
                            <CircleCheck height="16" width="16" />
                          ) : check?.solved === true ? (
                            <Tick height="16" width="16" />
                          ) : (
                            <Cross height="16" width="16" />
                          )}
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "400",
                              color: "#919293",
                            }}
                          >
                            {check.label}
                          </span>
                        </div>
                      ))
                    : section.inputs.map((input) => (
                        <div
                          className="d-flex justify-content-start mb-1 mt-2"
                          style={{ gap: "10px" }}
                          key={input.id}
                        >
                          <CircleCheck height="16" width="16" />
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "400",
                              color: "#919293",
                            }}
                          >
                            {input.title}
                          </span>
                        </div>
                      ))}
                  {(hasChecks
                    ? relevantChecks.length
                    : section.inputs.length) <= 2 && (
                    <span className="learn_badge">
                      {t("Learn More")}{" "}
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M5.1 4.5H10.5M10.5 4.5V9.9M10.5 4.5L4.5 10.5"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </span>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};
export default Placement;
